import React, { FunctionComponent } from "react"

interface StarIconProps {}

const StarIcon: FunctionComponent<StarIconProps> = () => {
  return (
    <svg
      width="66"
      height="64"
      viewBox="0 0 66 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_955_659)">
        <path
          d="M33.0002 12.334L38.1502 22.7673L49.6668 24.4507L41.3335 32.5673L43.3002 44.034L33.0002 38.6173L22.7002 44.034L24.6668 32.5673L16.3335 24.4507L27.8502 22.7673L33.0002 12.334Z"
          fill="#FFC200"
          stroke="#FFC200"
          stroke-width="3.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_955_659"
          x="-1"
          y="-1"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_955_659"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0 0 0 0 0.32 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_955_659"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_955_659"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default StarIcon
